module.exports = __webpack_public_path__ + "content2-eb649c19f40a1f4178d8.png";